require('../../styles/main.scss');
require('../../components/raq-cta-item/raq-cta-item.tag');

import { isModalRAQ } from '../../core/utils';
riot.tag2('raq-wrapper', '<yield></yield>', '', 'class="raq-wrapper {opts.theme} {state} {stepDealer} {stepForm} {stepVehicle} {raqLook1}"', function(opts) {
    const params = require('../../core/params');
    const dealers = require('../../core/dealers');
    const CONSTANTS = require('../../core/platform/constants.js').default;

    const self = this;
    const dealerOrigin = 'dealer';
    const vehicleOrigin = 'vehicle';
    const raqLook1Class = 'raq-look-1';

    self.mixin('cookie');
    self.mixin('bus');
    self.stepDealer = '';
    self.stepForm = '';
    self.stepVehicle = '';
    self.raqLook1 = isModalRAQ() ? '' : raqLook1Class;
    self.formError = false;

    self.state = 'is-loading';
    self.confirmation = {
      title: null,
      copy: null,
      ctas: null,
    };

    function changeState(args) {
      self.state = args.state;
      self.confirmation.title = args.title;
      self.confirmation.copy = args.copy;
      self.confirmation.ctas = args.ctas;
      self.update();
      window.scrollTo(0, 0);
    }

    function handleError() {
      changeState({ state: 'is-error' });
    }

    function goToDefault() {
      changeState({ state: 'is-default' });
    }

    function updateDealerData() {
      dealers.getFirstDealerByZipcode(self.cookie.get(CONSTANTS.zipcodeCookieName),
        self.cookie.get(CONSTANTS.preferredDealerIdCookieName))
        .then((response) => {
          self.bus.trigger(self.bus.EVENTS.DEALERS.UPDATE_DEALER_CARD, response.dealerId, false, false);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    function updateUserData() {
      self.userData = params.userData();
      self.update();
    }

    function updateStepPointer(event) {
      if (event) {
        const eventOriginName = event.origin;
        const eventOriginSelect = event.unselect;

        if (eventOriginName === vehicleOrigin) {
          if (eventOriginSelect) {
            self.stepForm = '';
          } else {
            self.stepVehicle = 'vehicle-visited';
          }
        } else if (eventOriginName === dealerOrigin) {
          if (eventOriginSelect) {
            self.stepVehicle = '';
            self.stepDealer = '';
          } else {
            self.stepDealer = 'dealer-visited';
          }
        }
        self.update();
      }
    }

    // Function to show form global error when form has invalid fields
    function showFormError(validFields) {
      self.formError = !validFields;
      self.update();
    }

    self.on('mount', () => {
      self.userData = params.getParams();
      self.state = 'is-default';
      self.bus.trigger(self.bus.EVENTS.CONTAINER.MOUNTED);
    });

    self.goToDefault = goToDefault;

    self.bus.on(self.bus.EVENTS.CONTAINER.CHANGESTATE, changeState);
    self.bus.on(self.bus.EVENTS.CONTAINER.ERROR, handleError);
    self.bus.on(self.bus.EVENTS.DEALERS.DEALER_FETCHED, updateUserData);
    self.bus.on(self.bus.EVENTS.VEHICLE.UPDATED, updateUserData);
    self.bus.on(self.bus.EVENTS.DEALERS.UPDATE, updateDealerData);
    self.bus.on(self.bus.EVENTS.STEPS.VEHICLE_UPDATED, updateStepPointer);
    self.bus.on(self.bus.EVENTS.STEPS.DEALER_UPDATED, updateStepPointer);
    self.bus.on(self.bus.EVENTS.FORM.SHOW_GLOBAL_ERROR, showFormError);
});
